export const getUserLocation = (callback, errorCallback) => {
    if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(callback, errorCallback)
    }
}

const filterGoalItems = (newItems, oldItems, formType) => {
    // Orders may appear in both newItems (Redux selectedPackets) and oldItems
    // (goal_items from a previous session) when undelivered packets were
    // preselected. Deduplicate by uuid so they aren't double-counted in
    // all_enrollment and discount tier math. newItems win on collide — safe
    // because delivered / ve_delivered rows never enter the cart (EnrollmentBase
    // preselection), so lifecycle-bearing old rows are not stripped by a
    // uuid match. Items without a uuid are new packets that haven't been
    // persisted yet and always pass through — packets get a uuid only on the
    // server response.
    const merged = [
        ...newItems,
        ...oldItems.filter((item) =>
            formType !== 'modification'
                ? item.delivered && item.season_active
                : item.delivered || item.ve_delivered
        )
    ]
    const seen = new Set()
    return merged.filter((item) => {
        if (!item.uuid) return true
        if (seen.has(item.uuid)) return false
        seen.add(item.uuid)
        return true
    })
}

const formatGoalItemsPerType = (oldGoalItems, newGoalItems) => {
    return {
        enrollment: newGoalItems,
        modification:
            oldGoalItems &&
            filterGoalItems(newGoalItems, oldGoalItems, 'modification'),
        're-enrollment':
            oldGoalItems &&
            filterGoalItems(newGoalItems, oldGoalItems, 're-enrollment')
    }
}

export const formatPayloadToClientObject = (payload) => {
    const goalItems = []
    let allEnrollment = 0
    payload?.packets?.forEach((packet) => {
        const goalItem = {
            desired_units: packet.size?.toString(),
            desired_units_display: packet.size_display?.toString(),
            price: packet.price,
            hide_price: packet.hidePrice,
            unit: packet.unit,
            product: {
                id: packet.product_id,
                name: typeof packet.name !== 'undefined' ? packet.name : ''
            },
            uuid: packet.uuid,
            package_id: packet.package_id
        }

        goalItems.push(goalItem)
        // the plus in front of the packet.price converts any string price to number data type
        allEnrollment += +packet.price
    })
    // Update payload fields
    payload.sf_id = payload.client_id ? payload.client_id : payload.sf_id
    payload.fullname = `${payload.firstname || ''} ${payload.lastname || ''}`
    payload.certified_for_delivery = 'False'
    payload.all_enrollment = allEnrollment
    payload.goal_items = formatGoalItemsPerType(payload.goal_items, goalItems)[
        payload.form_type
    ]
    return payload
}
